module.exports = __webpack_public_path__ + "static/media/question.3f7d9151.png";